import * as Mod1 from "./discourse/components/yearly-review-admin-notice";
import * as Mod2 from "./discourse/initializers/yearly-review-admin-notice";
const compatModules = {
  "discourse/components/yearly-review-admin-notice": Mod1,
  "discourse/initializers/yearly-review-admin-notice": Mod2,
};
export { compatModules };
export default compatModules;
